// dna_frontend/src/pages/Dashboard.js
// (Copy và thay thế toàn bộ file)

import React, { useState, useEffect } from 'react'; 
import api from '../services/api'; 
import { useNavigate } from 'react-router-dom';
import { Bar, Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

import './Dashboard.css';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
);

function Dashboard() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user'));
  
  const [stats, setStats] = useState({
    totalLietSi: 0,
    chuaCoLietSi: 0,
    TongSo: 0,
    KhongThu_KLL: 0,
    KhongThu_KNC: 0,
    KhongThu_OXKV: 0,
    KhongThu_Truoc: 0,
    KhongThu_DuPhong: 0,
    KhongThu_DeNghiXoa: 0,
    TongCanThu: 0,
    DaThu: 0,
    ChuaThu: 0,
    TyLeDaThu: 0
  });
  const [statsByXa, setStatsByXa] = useState([]); 
  const [loadingStats, setLoadingStats] = useState(true);
  const [loadingXaStats, setLoadingXaStats] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      setLoadingStats(true);
      try {
        const res = await api.get('/dashboard/stats'); 
        setStats(res.data); 
      } catch (error) {
        console.error("Lỗi tải số liệu thống kê toàn tỉnh:", error);
      } finally {
        setLoadingStats(false);
      }
    };
    
    const fetchStatsByXa = async () => {
        setLoadingXaStats(true);
         try {
            const res = await api.get('/dashboard/stats-by-xa'); 
            setStatsByXa(res.data); 
         } catch (error) {
            console.error("Lỗi tải số liệu thống kê xã:", error);
         } finally {
             setLoadingXaStats(false);
         }
    };

    fetchStats();
    fetchStatsByXa();
  }, []); 

  const handleSync = () => {
    window.location.reload(); 
  };
  
  const thuMauChartData = {
    labels: [
        'Đã thu mẫu', 'Chưa thu (Còn lại)', 
        'KLL', 'KNC', 'Ở xa', 'Thu trước', 'Dự phòng', 'Đề nghị xóa'
    ],
    datasets: [
      {
        label: 'Thống kê thân nhân',
        data: [
          stats.DaThu,
          stats.ChuaThu,
          stats.KhongThu_KLL,
          stats.KhongThu_KNC,
          stats.KhongThu_OXKV,
          stats.KhongThu_Truoc,
          stats.KhongThu_DuPhong,
          stats.KhongThu_DeNghiXoa,
        ],
        backgroundColor: [
            '#28a745', '#dc3545', '#ffc107', '#ffc107', 
            '#ffc107', '#17a2b8', '#6f42c1', '#6c757d'
        ],
        hoverOffset: 4,
      },
    ],
  };
  
  // (*** SỬA (Theo yêu cầu) ***) Xử lý dữ liệu cho biểu đồ ngang
  const processedXaData = statsByXa
      .filter(xa => xa.TyLeDaThu > 0) // Lọc các xã > 0%
      .sort((a, b) => b.TyLeDaThu - a.TyLeDaThu); // Sắp xếp giảm dần

  // (*** SỬA (Theo yêu cầu) ***) Cập nhật data
  const xaBarChartData = {
    labels: processedXaData.map(xa => xa.ten_xa), // Tên xã
    datasets: [
      {
        label: 'Tỷ lệ đã thu (%)',
        data: processedXaData.map(xa => xa.TyLeDaThu.toFixed(2)), // Tỷ lệ
        backgroundColor: '#28a745', 
      },
    ],
  };
  
  const chartOptions = {
      responsive: true,
      maintainAspectRatio: false, 
  };
  
  // (*** SỬA (Theo yêu cầu) ***) Cập nhật options
  const barChartOptions = {
       ...chartOptions,
       indexAxis: 'y', // Chuyển thành biểu đồ ngang
       scales: { 
           x: { // Trục X bây giờ là Tỷ lệ
               beginAtZero: true,
               max: 100, // Tối đa 100%
               title: {
                   display: true,
                   text: 'Tỷ lệ đã thu (%)'
               }
           },
           y: { // Trục Y là tên xã
               beginAtZero: true
           } 
       },
       plugins: {
           legend: {
               display: false // Chỉ có 1 dataset, không cần legend
           }
       }
  };


  return (
    <div className="dashboard-container"> 
      <div className="dashboard-header">
         <h1 style={{ marginTop: '0' }}>Dashboard Theo dõi Tiến độ</h1>
         <button onClick={handleSync} className="btn-sync">
           Đồng bộ / Tải lại
         </button>
      </div>

      {/* (Grid thống kê giữ nguyên) */}
      <div className="stats-grid-dashboard">
        <div className="stat-box">
          <h3>Tổng số Liệt sĩ</h3>
          <p className="stat-number" style={{ color: '#6f42c1' }}>
            {loadingStats ? '...' : stats.totalLietSi}
          </p>
        </div>
        <div className="stat-box">
          <h3>Tổng số Thân nhân</h3>
          <p className="stat-number" style={{ color: '#007bff' }}>
            {loadingStats ? '...' : stats.TongSo}
          </p>
        </div>
        <div className="stat-box">
          <h3>Chưa có Liệt sĩ</h3>
          <p className="stat-number stat-number-danger">
             {loadingStats ? '...' : stats.chuaCoLietSi}
          </p>
        </div>
        <div className="stat-box">
          <h3>Tổng cần thu</h3>
          <p className="stat-number" style={{ color: '#17a2b8' }}>
             {loadingStats ? '...' : stats.TongCanThu}
          </p>
        </div>
         <div className="stat-box">
          <h3>Đã thu mẫu</h3>
          <p className="stat-number" style={{ color: '#28a745' }}>
             {loadingStats ? '...' : stats.DaThu}
          </p>
        </div>
        <div className="stat-box">
          <h3>Tỷ lệ Đã thu</h3>
          <p className="stat-number" style={{ color: '#28a745' }}>
             {loadingStats ? '...' : stats.TyLeDaThu.toFixed(2)}%
          </p>
        </div>
         <div className="stat-box">
          <h3>Chưa thu (Còn lại)</h3>
          <p className="stat-number stat-number-danger">
             {loadingStats ? '...' : stats.ChuaThu}
          </p>
        </div>
        <div className="stat-box">
          <h3>Không thu (6 loại)</h3>
          <p className="stat-number" style={{ color: '#ffc107' }}>
             {loadingStats ? '...' : (
                stats.KhongThu_KLL + stats.KhongThu_KNC + stats.KhongThu_OXKV + 
                stats.KhongThu_Truoc + stats.KhongThu_DuPhong + stats.KhongThu_DeNghiXoa
             )}
          </p>
        </div>
      </div>
      
       <div className="chart-grid">
           <div className="chart-box">
                <h3>Phân loại Thân nhân (Toàn tỉnh)</h3>
                <div className="chart-container">
                   {loadingStats ? <p>Đang tải...</p> : <Doughnut data={thuMauChartData} options={chartOptions} />}
                </div>
           </div>
           
           {/* (*** SỬA (Theo yêu cầu) ***) Biểu đồ cột ngang */}
           <div className="table-section">
            <h3>Biểu đồ Tỷ lệ Thu mẫu (Theo Xã, > 0%)</h3>
            {/* (SỬA) Thêm overflowY: 'auto' để cuộn */}
            <div className="chart-box" style={{height: '400px', overflowY: 'auto'}}>
              {loadingXaStats ? <p>Đang tải...</p> : (
                  <div className="chart-container-bar-horizontal" style={{ height: `${processedXaData.length * 30}px`, minHeight: '350px' }}>
                      <Bar data={xaBarChartData} options={barChartOptions} />
                  </div>
              )}
            </div>
          </div>
       </div>

      
      {/* (Bảng chi tiết giữ nguyên) */}
      <div className="table-section">
        <h3>Chi tiết Tiến độ theo Xã</h3>
        <div className="table-wrapper-dashboard">
          <table className="responsive-table-dashboard">
            <thead>
              <tr>
                <th rowSpan="2">STT</th>
                <th rowSpan="2">Tên Xã</th>
                <th rowSpan="2">Tổng số</th>
                <th colSpan="6">Không thu mẫu đợt này</th>
                <th rowSpan="2">Tổng cần thu</th>
                <th rowSpan="2">Đã thu</th>
                <th rowSpan="2">Tỷ lệ (%)</th>
                <th rowSpan="2">Chưa thu</th>
                <th rowSpan="2">Chưa có LS</th>
              </tr>
              <tr className="sub-header">
                <th>KLL</th>
                <th>KNC</th>
                <th>Ở xa</th>
                <th>Thu trước</th>
                <th>Dự phòng</th>
                <th>Đề nghị xóa</th>
              </tr>
            </thead>
            <tbody>
              {loadingXaStats ? (
                 <tr><td colSpan="14" style={{textAlign: 'center', padding: '20px'}}>Đang tải dữ liệu xã...</td></tr>
              ) : (
                statsByXa.map((xa, index) => (
                  <tr key={xa.xa_id}>
                    <td data-label="STT">{index + 1}</td>
                    <td data-label="Tên Xã" style={{ fontWeight: 'bold', textAlign: 'left' }}>{xa.ten_xa}</td>
                    <td data-label="Tổng số">{xa.TongSo}</td>
                    <td data-label="KLL">{xa.KhongThu_KLL}</td>
                    <td data-label="KNC">{xa.KhongThu_KNC}</td>
                    <td data-label="Ở xa">{xa.KhongThu_OXKV}</td>
                    <td data-label="Thu trước">{xa.KhongThu_Truoc}</td>
                    <td data-label="Dự phòng">{xa.KhongThu_DuPhong}</td>
                    <td data-label="Đề nghị xóa">{xa.KhongThu_DeNghiXoa}</td>
                    <td data-label="Tổng Cần thu" style={{ background: '#eaf8fa' }}>{xa.TongCanThu}</td>
                    <td data-label="Đã thu" style={{ background: '#eafaf1' }}>{xa.DaThu}</td>
                    <td data-label="Tỷ lệ (%)" style={{ background: '#eafaf1' }}>{xa.TyLeDaThu.toFixed(2)}%</td>
                    <td data-label="Chưa thu" style={{ color: 'red', fontWeight: 'bold' }}>
                      {xa.ChuaThu}
                    </td>
                    <td data-label="Chưa có LS" style={{ color: xa.ChuaCoLietSi > 0 ? 'red' : 'inherit' }}>
                      {xa.ChuaCoLietSi}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    
    </div>
  );
}

export default Dashboard;